import axios from 'axios'

const state = {
    loading: false,
    listEvents: {pathLogo: '', upcomingEvents: [], nowEvents: [], passEvents: []}
}

const getters = {
    loading: (state) => state.loading,
    listEvents: (state) => state.listEvents,
    listEventById: (state) => (id) => {
        let event = state.listEvents.upcomingEvents.find((event) => event.id === id)
        if (!event) event = state.listEvents.nowEvents.find((event) => event.id === id)
        if (!event) event = state.listEvents.passEvents.find((event) => event.id === id)
        return event
    },
}

const mutations = {
    SET_LOADING(state) {
        state.loading = !state.loading
    },
    ADD_LIST_EVENT(state, listEvents) {
        state.listEvents = listEvents
    }
}
const actions = {
    async searchAllEvent(context) {
        context.commit('SET_LOADING')
        const uriApp = context.rootGetters.uriApp
        await axios.get(uriApp + `/api/events`).then((response) => {
            const {upcoming_envents, now_events, url_photo, pass_envents} = response.data
            context.commit('ADD_LIST_EVENT', {
                pathLogo: url_photo,
                upcomingEvents: upcoming_envents,
                nowEvents: now_events,
                passEvents: pass_envents
            })
        }).catch((error) => {
            console.error(error)
        })
        context.commit('SET_LOADING')
    },
}
export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
    strict: true
}
